import { combineReducers } from 'redux'
import productos from './productos'
import header from './header'
import usuario from './usuario'
import pedidos from './pedidos'

const rootReducer = combineReducers({
  productos,
  menu:header,
  usuario:usuario,
  pedidos:pedidos

})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js